<template>
  <div>
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="appstore"></a-icon>
          <span>SSL 证书</span>
        </a-space>
      </template>
      <span>SSL 证书包含名称、签发机构、到期时间等信息。</span>
    </a-page-header>

    <a-card :bordered="false">
      <ssl-certificate-table
        :refresh="refresh"
        :tools-list="['setting', 'reload', 'search', 'leftTool', 'export']"
      ></ssl-certificate-table>
    </a-card>
  </div>
</template>

<script>
import SSLCertificateTable from '@/components/table/SSLCertificateTable/index.vue'

export default {
  name: 'SSLCertificate',
  components: {
    'ssl-certificate-table': SSLCertificateTable
  },
  data () {
    return {
      refresh: false
    }
  }
}
</script>
